import baseAPI from '@/api/base';
import {
  EditAPIKey,
  GetAPIKey,
  RegisterAPIKey,
} from '@/dtos/api_key.dto';
import {
  DELETE_API_KEY_URL,
  EDIT_API_KEY_URL,
  GET_API_KEY_URL,
  REGISTER_API_KEY_URL,
  TOGGLE_API_KEY_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class apiKey {
  static getAPIKeys = async (
    getapiKey: GetAPIKey
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_API_KEY_URL, {
      params: getapiKey,
    });
    console.log('response', response);
    return response;
  };

  static registerAPIKey = async (
    registerAPIKey: RegisterAPIKey
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_API_KEY_URL,
      {
        ...registerAPIKey,
      }
    );
    console.log('response', response);
    return response;
  };

  static editAPIKey = async (
    editAPIKey: EditAPIKey
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_API_KEY_URL,
      {
        ...editAPIKey,
      }
    );
    return response;
  };

  static toggleAPIKeyIsActive = async (
    editAPIKey: EditAPIKey
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_API_KEY_IS_ACTIVE_URL,
      {
        ...editAPIKey,
      }
    );
    return response;
  };

  static deleteAPIKey = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_API_KEY_URL}/${id}`
    );
    return response;
  };
}

export default apiKey;
